import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {selectLastLavoratore, selectLavoratore, setupContratto} from "@commons/core.slice";
import {useLazyGetLavoratoreQuery} from "@commons/features/lavoratore/lavoratore.api";
import {useEffect} from "react";

/**
 * hook per rilevare il lavoratore/contratto corrente
 * Se non vi è un lavoratore/contratto viene valutato l'eventuale lavoratore/contratto della sessione precedente (ovvero prima di aver ricaricato la pagina (F5))
 */

// = () => {}
export const useLavoratore = (onError: (message: string) => void) => {
    const dispatch = useAppDispatch();
    const contratto: LavoratoreRecord | null = useAppSelector(selectLavoratore);
    const lastContratto: Pick<LavoratoreRecord, 'id'> | null = useAppSelector(selectLastLavoratore);
    const [getTrigger, result, promiseInfo] = useLazyGetLavoratoreQuery();

    useEffect(() => {
        if (!contratto && lastContratto) {
            getTrigger({idDip: lastContratto.id}, false).then((res) => {
                if (res && res.isSuccess) {
                    dispatch(setupContratto(res.data))
                } else if (res.isError) {
                    if ('data' in res.error) {
                        // @ts-ignore
                        const message = res.error.data.message;
                        onError(message);
                    } else
                        onError("Errore generico!");
                }
            })
        }
    }, [contratto, lastContratto, dispatch, getTrigger, onError])

    return contratto;
}